import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"


export default /*@__PURE__*/_defineComponent({
  __name: 'TableCell',
  props: {
    class: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("td", {
    class: _normalizeClass(["px-6 py-4 whitespace-nowrap", _ctx.$props.class])
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}
}

})